
import Vue from "vue"
import Router from "vue-router"

Vue.use(Router)
const isHashMode = window.location.hash.startsWith('#/');
const router = new Router({
  // mode:'history',
  mode: isHashMode ? 'hash' : 'history',
  routes: [{
    path: "/",
    name: "Marketing",
    component: resolve => require(["@/views/Marketing"], resolve),
    meta: {
      title: "自考报名",
    }
  },
  {
    path: "/404",
    name: "404",
    component: resolve => require(["@/views/404"], resolve),
    meta: {
      title: "页面不存在",
    }
  },
  {
    path: "/Counseling",
    name: "Counseling",
    component: resolve => require(["@/views/Counseling"], resolve),
    meta: {
      title: "成考辅导",
    }
  },
  {
    path: "/Integral",
    name: "Integral",
    component: resolve => require(["@/views/newIntegral"], resolve),
    meta: {
      title: "积分入户",
    }
  },
  {
    path: "/Professional_presentation",
    name: "Professional_presentation",
    component: resolve => require(["@/views/Professional_presentation"], resolve),
    meta: {
      title: "德鹏教育",
    }
  },
  {
    path: "/BiguoServiceSpread/:id",
    name: "BiguoServiceSpread",
    component: resolve => require(["@/views/OrganizationAdd"], resolve),
    meta: {
      title: "机构入驻",
    }
  },
  {
    path: "/InstitutionalEnrollment/:id",
    name: "InstitutionalEnrollment",
    component: resolve => require(["@/views/InstitutionalEnrollment"], resolve),
    meta: {
      title: "推广招生",
    }
  },
  {
    path: "/StudentEnrollment/:id",
    name: "StudentEnrollment",
    component: resolve => require(["@/views/StudentEnrollment"], resolve),
    meta: {
      title: "邀请好友报名",
    }
  },
  // {
  //   path: "/OrganizationList",
  //   name: "OrganizationList",
  //   component: resolve => require(["@/views/OrganizationList"], resolve),
  //   meta: {
  //     title: "机构列表",
  //   }
  // },
  {
    path: "/OrganizationList",
    name: "OrganizationList",
    component: resolve => require(["@/views/OrganizationList"], resolve),
    meta: {
      title: "机构",
    }
  },
  {
    path: "/orgListSchool",
    name: "orgListSchool",
    component: resolve => require(["@/views/orgListSchool"], resolve),
    meta: {
      title: "我要找学校",
    }
  },
  {
    path: "/OrganizationDetail/:id",
    name: "OrganizationDetail",
    component: resolve => require(["@/views/OrganizationDetail"], resolve),
    meta: {
      title: "机构详情",
    }
  },
  {
    path: "/OrganizationEnroll",
    name: "OrganizationEnroll",
    component: resolve => require(["@/views/OrganizationEnroll"], resolve),
    meta: {
      title: "机构报名",
    }
  },
  {
    path: "/yamiRefund",
    name: "yamiRefund",
    component: resolve => require(["@/views/yamiRefund"], resolve),
    meta: {
      title: "笔果押密售后中心",
    }
  },
  {
    path: "/yamiElectronicSend",
    name: "yamiElectronicSend",
    component: resolve => require(["@/views/yamiElectronicSend"], resolve),
    meta: {
      title: "重置押密领取状态",
    }
  },
  {
    path: "/yamiElectronic",
    name: "yamiElectronic",
    component: resolve => require(["@/views/yamiElectronic"], resolve),
    meta: {
      title: "笔果押密电子档领取中心",
    }
  },
  {
    path: "/app/help",
    name: "appHelp",
    component: resolve => require(["@/views/appHelp"], resolve),
    meta: {
      title: "帮助中心",
    }
  },
  {
    path: "/englishTwo",
    name: "englishTwo",
    component: resolve => require(["@/views/englishTwo"], resolve),
    meta: {
      title: "自考英语二专项辅导",
    }
  },
  {
    path: "/english",
    name: "english",
    component: resolve => require(["@/views/english"], resolve),
    meta: {
      title: "自考英语二专项辅导",
    }
  },
  {
    path: "/womenDayDraw",
    name: "drawWomenDay",
    component: resolve => require(["@/views/drawWomenDay"], resolve),
    meta: {
      title: "3.8 女神节活动",
    }
  },
  {
    path: "/everyDayDraw",
    name: "drawEveryDay",
    component: resolve => require(["@/views/drawEveryDay2"], resolve),
    meta: {
      title: "笔果每日抽奖活动",
    }
  },
  {
    path: "/everyDayDraws",
    name: "everyDayDraws",
    component: resolve => require(["@/views/drawEveryDay"], resolve),
    meta: {
      title: "每日抽奖",
    }
  },
  {
    path: "/drawLaborDay",
    name: "drawLaborDay",
    component: resolve => require(["@/views/drawLaborDay"], resolve),
    meta: {
      title: "五一大礼,分享欢喜",
    }
  },
  {
    path: "/drawLog",
    name: "drawLog",
    component: resolve => require(["@/views/drawLog"], resolve),
    meta: {
      title: "中奖记录",
    }
  },
  {
    path: "/dataCenter/appBiguoZikao",
    name: "dataCenterAppBiguoZikao",
    component: resolve => require(["@/views/dataCenterAppBiguoZikao"], resolve),
    meta: {
      title: "自考快速取证班",
    }
  },
  {
    path: "/dataCenter/appBiguoChengkao",
    name: "dataCenterAppBiguoChengkao",
    component: resolve => require(["@/views/dataCenterAppBiguoChengkao"], resolve),
    meta: {
      title: "通过抵学费，不过全额退",
    }
  },
  {
    path: "/dataCenter/wxnumberBiguoZikao",
    name: "dataCenterWXnumberBiguoZikao",
    component: resolve => require(["@/views/dataCenterWXnumberBiguoZikao"], resolve),
    meta: {
      title: "自考快速取证班",
    }
  },
  {
    path: "/dataCenter/wxnumberDepeng",
    name: "dataCenterWXnumberDepeng",
    component: resolve => require(["@/views/dataCenterWXnumberDepeng"], resolve),
    meta: {
      title: "学历快速提升班",
    }
  },
  {
    path: "/dataCenter/toutiaoZikao",
    name: "dataCenterToutiaoZikao",
    component: resolve => require(["@/views/dataCenterToutiaoZikao"], resolve),
    meta: {
      title: "学历快速提升班",
    }
  },
  {
    path: "/app/appTeacherGuide",
    name: "appTeacherGuide",
    component: resolve => require(["@/views/appTeacherGuide"], resolve),
    meta: {
      title: "考证指南",
    }
  },
  {
    path: "/appdownloadGuide",
    name: "appdownloadGuide",
    component: resolve => require(["@/views/appdownloadGuide"], resolve),
    meta: {
      title: "APP客户端",
    }
  },
  {
    path: "/appDownloadNew",
    name: "appDownloadNew",
    component: resolve => require(["@/views/appDownloadNew"], resolve),
    meta: {
      title: "自考笔果题库APP下载",
    }
  },
  {
    path: "/appdownloadGuideAndroid",
    name: "appdownloadGuideAndroid",
    component: resolve => require(["@/views/appdownloadGuideAndroid"], resolve),
    meta: {
      title: "APP客户端(Android)",
    }
  },
  {
    path: "/register",
    name: "register",
    // component: resolve => require(["@/views/register"], resolve),
    component: resolve => require(["@/views/404"], resolve),
    meta: {
      title: "新用户注册",
    }
  },
  {
    path: "/shareCode",
    name: "shareCode",
    component: resolve => require(["@/views/shareCode"], resolve),
    meta: {
      title: "面对面邀请",
    }
  },
  {
    path: "/famousSchool",
    name: "famousSchool",
    component: resolve => require(["@/views/famousSchool"], resolve),
    meta: {
      title: "名校推荐",
    }
  },
  {
    path: "/signupWebview",
    name: "signupWebview",
    component: resolve => require(["@/views/signupWebview"], resolve),
    meta: {
      title: "我要报名",
    }
  },
  {
    path: "/biGuoLottery",
    name: "biGuoLottery",
    component: resolve => require(["@/views/biGuoLottery"], resolve),
    meta: {
      title: "笔果福利大回馈",
    }
  },
  {
    path: "/biGuoLotteryBottom",
    name: "biGuoLotteryBottom",
    component: resolve => require(["@/views/biGuoLotteryBottom"], resolve),
    meta: {
      title: "7周年福利大转盘",
    }
  },
  {
    path: "/biGuoClockInLottery",
    name: "biGuoClockInLottery",
    component: resolve => require(["@/views/biGuoClockInLottery"], resolve),
    meta: {
      title: "坚持打卡迎战自考",
    }
  },

  {
    path: "/learnPlan",
    name: "learnPlan",
    component: resolve => require(["@/views/learnPlan"], resolve),
    meta: {
      title: "学梦计划",
    }
  },
  {
    path: "/userVIP",
    name: "userVIP",
    component: resolve => require(["@/views/userVIP"], resolve),
    meta: {
      title: "笔果折扣卡",
    }
  },
  {
    path: "/vipAgreement",
    name: "vipAgreement",
    component: resolve => require(["@/views/vipAgreement"], resolve),
    meta: {
      title: "笔果折扣卡服务协议",
    }
  },
  {
    path: "/vipAgreements",
    name: "vipAgreements",
    component: resolve => require(["@/views/vipAgreements"], resolve),
    meta: {
      title: "笔果会员服务协议",
    }
  },
  {
    path: "/compensation",
    name: "compensation",
    component: resolve => require(["@/views/compensation"], resolve),
    meta: {
      title: "笔果用户补偿",
    }
  },
  {
    path: "/privacy",
    name: "privacy",
    component: resolve => require(["@/views/privacy"], resolve),
    meta: {
      title: "隐私政策",
    }
  },
  {
    path: "/miniAppPrivacy",
    name: "miniAppPrivacy",
    component: resolve => require(["@/views/miniAppPrivacy"], resolve),
    meta: {
      title: "隐私政策",
    }
  },
  {
    path: "/newPrivacy",
    name: "newPrivacy",
    component: resolve => require(["@/views/privacy"], resolve),
    meta: {
      title: "隐私政策",
    }
  },
  {
    path: "/wxScanCode",
    name: "wxScanCode",
    component: resolve => require(["@/views/wxScanCode"], resolve),
    meta: {
      title: "扫一扫",
    }
  },
  {
    path: "/test",
    name: "test",
    component: resolve => require(["@/views/test"], resolve),
    meta: {
      title: "扫一扫",
    }
  },
  {
    path: "/apply",
    name: "apply",
    component: resolve => require(["@/views/apply"], resolve),
    meta: {
      title: "笔果官方学历提升渠道",
    }
  },
  {
    path: "/appMultipleChoice",
    name: "appMultipleChoice",
    component: resolve => require(["@/views/appMultipleChoice"], resolve),
    meta: {
      title: "自考笔果题库",
    }
  },
  {
    path: "/appQuestions",
    name: "appQuestions",
    component: resolve => require(["@/views/appQuestions"], resolve),
    meta: {
      title: "自考笔果题库",
    }
  },
  {
    path: "/integralDraw",
    name: "integralDraw",
    component: resolve => require(["@/views/integralDraw"], resolve),
    meta: {
      title: "积分抽奖",
    }
  },
  {
    path: "/topicShare",
    name: "topicShare",
    component: resolve => require(["@/views/topicShare"], resolve),
    meta: {
      title: "自考笔果题库",
    }
  },
  {
    path: "/appGroup",
    name: "appGroup",
    component: resolve => require(["@/views/appGroup"], resolve),
    meta: {
      title: "拼团详情",
    }
  },
  {
    path: "/appGroupOne",
    name: "appGroupOne",
    component: resolve => require(["@/views/appGroupOne"], resolve),
    meta: {
      title: "拼团详情",
    }
  },
  {
    path: "/applyForm",
    name: "applyForm",
    component: resolve => require(["@/views/applyForm"], resolve),
    meta: {
      title: "自考笔果题库",
    }
  },
  {
    path: "/newCopy",
    name: "newCopy",
    component: resolve => require(["@/views/newCopy"], resolve),
    meta: {
      title: "新手指南",
    }
  },
  {
    path: "/continue",
    name: "continue",
    component: resolve => require(["@/views/continue"], resolve),
    meta: {
      title: "继续学",
    }
  },
  {
    path: "/Agreement",
    name: "Agreement",
    component: resolve => require(["@/views/Agreement"], resolve),
    meta: {
      title: "用户协议",
    }
  },
  {
    path: "/schoolRules",
    name: "schoolRules",
    component: resolve => require(["@/views/schoolRules"], resolve),
    meta: {
      title: "校纪校规",
    }
  },
  {
    path: "/ExtendRule",
    name: "ExtendRule",
    component: resolve => require(["@/views/ExtendRule"], resolve),
    meta: {
      title: "笔果推广员（团长）规则说明",
    }
  },
  {
    path: "/GetCashRule",
    name: "GetCashRule",
    component: resolve => require(["@/views/GetCashRule"], resolve),
    meta: {
      title: "提现规则",
    }
  },
  {
    path: "/ymxy",
    name: "ymxy",
    component: resolve => require(["@/views/ymxy"], resolve),
    meta: {
      title: "押密协议",
    }
  },
  {
    path: "/SuperVIP",
    name: "SuperVIP",
    component: resolve => require(["@/views/SuperVIP"], resolve),
    meta: {
      title: "笔果题库超级vip题库服务条款",
    }
  },
    {
    path: "/renewals",
    name: "renewals",
    component: resolve => require(["@/views/renewals"], resolve),
    meta: {
      title: "开通笔果折扣卡",
    }
  },
  {
    path: "/consultGroup",
    name: "consultGroup",
    component: resolve => require(["@/views/consultGroup"], resolve),
    meta: {
      title: "资讯群",
    }
  },
  {
    path: "/drainageGroup",
    name: "drainageGroup",
    component: resolve => require(["@/views/drainageGroup"], resolve),
    meta: {
      title: "笔果学历提升专属群",
    }
  },
  {
    path: "/drainageGroupCopy",
    name: "drainageGroupCopy",
    component: resolve => require(["@/views/drainageGroupCopy"], resolve),
    meta: {
      title: "笔果学历提升专属群",
      noCache: true
    }
  },
  {
    path: "/popularizeAssociation",
    name: "popularizeAssociation",
    component: resolve => require(["@/views/popularizeAssociation"], resolve),
    meta: {
      title: "笔果交流群",
      noCache: true
    }
  },
  {
    path: "/provinceCommunities",
    name: "provinceCommunities",
    component: resolve => require(["@/views/provinceCommunities"], resolve),
    meta: {
      title: "选择省份社群",
    }
  },
  {
    path: "/liveShare",
    name: "liveShare",
    component: resolve => require(["@/views/liveShare"], resolve),
    meta: {
      title: "直播分享",
    },
  },
    {
    path: "/xmPlan",
    name: "xmPlan",
    component: resolve => require(["@/views/xmPlan"], resolve),
    meta: {
      title: "成考学梦班",
    },
  },
  {
    path: "/collectMaterials",
    name: "collectMaterials",
    component: resolve => require(["@/views/collectMaterials"], resolve),
    meta: {
      title: "领取资料",
    },
  },
  {
    path: "/integralRule",
    name: "integralRule",
    component: resolve => require(["@/views/integralRule"], resolve),
    meta: {
      title: "积分规则",
    },
  },
  {
    path: "/applicationSchool",
    name: "applicationSchool",
    component: resolve => require(["@/views/applicationSchool"], resolve),
    meta: {
      title: "我要咨询",
    },
  },
  {
    path: "/historicalQuestions",
    name: "historicalQuestions",
    component: resolve => require(["@/views/historicalQuestions"], resolve),
    meta: {
      title: "历年真题小结",
    },
  },
  {
    path: "/questionInterface",
    name: "questionInterface",
    component: resolve => require(["@/views/questionInterface"], resolve),
    meta: {
      title: "高等数学真题",
    },
  },
  {
    path: "/coOperatingAgency",
    name: "coOperatingAgency",
    component: resolve => require(["@/views/coOperatingAgency"], resolve),
    meta: {
      title: "合作机构",
    },
  },
  {
    path: "/landingPage",
    name: "landingPage",
    component: resolve => require(["@/views/landingPage"], resolve),
    meta: {
      title: "自考笔果题库",
    },
  },
  {
    path: "/landingPageDspWyb",
    name: "landingPageDspWyb",
    component: resolve => require(["@/views/landingPageDspWyb"], resolve),
    meta: {
      title: "自考笔果题库",
    },
  },
  {
    path: "/download",
    name: "download",
    component: resolve => require(["@/views/download"], resolve),
    meta: {
      title: "自考笔果题库",
    },
  },
    {
    path: "/selfStudyExamAdvantage",
    name: "selfStudyExamAdvantage",
    component: resolve => require(["@/views/selfStudyExamAdvantage"], resolve),
    meta: {
      title: "小自考优势",
    },
  },
  {
    path: "/doubleTwelveGiftBag",
    name: "doubleTwelveGiftBag",
    component: resolve => require(["@/views/doubleTwelveGiftBag"], resolve),
    meta: {
      title: "1月注册礼包发放中",
    },
  },
  {
    path: "/contactBusiness",
    name: "contactBusiness",
    component: resolve => require(["@/views/contactBusiness"], resolve),
    meta: {
      title: "联系我们",
    },
  },
  {
    path: "/videoList",
    name: "videoList",
    component: resolve => require(["@/views/videoList"], resolve),
    meta: {
      title: "播放视频",
    },
  },
  {
    path: "/ttvideoList",
    name: "rrvideoList",
    component: resolve => require(["@/views/ttvideoList"], resolve),
    meta: {
      title: "播放视频",
    },
  },
  {
    path: "/bindPhonePage",
    name: "bindPhonePage",
    component: resolve => require(["@/views/bindPhonePage"], resolve),
    meta: {
      title: "绑定手机号",
      noCache: true,       // 缓存数据
    },
  },
  {
    path: "/eduTrusteeship",
    name: "eduTrusteeship",
    component: resolve => require(["@/views/eduTrusteeship"], resolve),
    meta: {
      title: "非全日制学历托管",
      noCache: true,       // 缓存数据
    },
  },
  {
    path: "/miniCode",
    name: "miniCode",
    component: resolve => require(["@/views/miniCode"], resolve),
    meta: {
      title: "小程序码",
      noCache: true,       // 缓存数据
    },
  },
  {
    path: "/shareInvitation",
    name: "shareInvitation",
    component: resolve => require(["@/views/shareInvitation"], resolve),
    meta: {
      title: "报名邀请",
    },
  },
  {
    path: "/payTuitionFees",
    name: "payTuitionFees",
    component: resolve => require(["@/views/payTuitionFees"], resolve),
    meta: {
      title: "缴纳学费",
    },
  },
  {
    path: "/paymentRecords",
    name: "paymentRecords",
    component: resolve => require(["@/views/paymentRecords"], resolve),
    meta: {
      title: "缴费记录",
    },
  },
  {
    path: "/learningReport",
    name: "learningReport",
    component: resolve => require(["@/views/learningReport"], resolve),
    meta: {
      title: "学习报告",
    },
  },
  {
    path: "/addCustomerService",
    name: "addCustomerService",
    component: resolve => require(["@/views/addCustomerService"], resolve),
    meta: {
      title: "添加客服",
    },
  },
  {
    path: "/dynamicDetails",
    name: "dynamicDetails",
    component: resolve => require(["@/views/dynamicDetails"], resolve),
    meta: {
      title: "动态详情",
    },
  },
  {
    path: "/yamiCkRefund",
    name: "yamiCkRefund",
    component: resolve => require(["@/views/yamiCkRefund"], resolve),
    meta: {
      title: "笔果成考押密售后中心",
    },
  },
  {
    path: "/feedBack",
    name: "feedBack",
    component: resolve => require(["@/views/feedBack"], resolve),
    meta: {
      title: "意见反馈",
    },
  },
  {
    path: "/infoCollectionChecklist",
    name: "infoCollectionChecklist",
    component: resolve => require(["@/views/infoCollectionChecklist"], resolve),
    meta: {
      title: "个人信息收集清单",
    },
  },
  {
    path: "/getLowPrices",
    name: "getLowPrices",
    component: resolve => require(["@/views/getLowPrices"], resolve),
    meta: {
      title: "优惠查询",
    },
  },
  {
    path: "/findAnAgency",
    name: "findAnAgency",
    component: resolve => require(["@/views/findAnAgency"], resolve),
    meta: {
      title: "帮我找机构",
    },
  },
  {
    path: "/myNeeds",
    name: "myNeeds",
    component: resolve => require(["@/views/myNeeds"], resolve),
    meta: {
      title: "我的需求",
    },
  },
  {
    path: "/studentRefundForm",
    name: "studentRefundForm",
    component: resolve => require(["@/views/studentRefundForm"], resolve),
    meta: {
      title: "退费单",
    },
  },
  {
    path: "/questionnaireSurvey",
    name: "questionnaireSurvey",
    component: resolve => require(["@/views/questionnaireSurvey"], resolve),
    meta: {
      title: "填写问卷",
    },
  },
  {
    path: "/followPublicAccount",
    name: "followPublicAccount",
    component: resolve => require(["@/views/followPublicAccount"], resolve),
    meta: {
      title: "关注公众号",
    },
  },
  {
    path: "/intelligentCustomerService",
    name: "intelligentCustomerService",
    component: resolve => require(["@/views/intelligentCustomerService"], resolve),
    meta: {
      title: "智能客服",
    },
  },
  {
    path: "/yamiLearningMethods",
    name: "yamiLearningMethods",
    component: resolve => require(["@/views/yamiLearningMethods"], resolve),
    meta: {
      title: "押密学习方法",
    },
  },
  {
    path: "/exclusiveDiscountCard",
    name: "exclusiveDiscountCard",
    component: resolve => require(["@/views/exclusiveDiscountCard"], resolve),
    meta: {
      title: "笔果专项折扣卡",
    },
  },
  {
    path: "/aliyunLivePlayback",
    name: "aliyunLivePlayback",
    component: resolve => require(["@/views/aliyunLivePlayback"], resolve),
    meta: {
      title: "直播回放",
    },
  },
  {
    path: "/learningMachine",
    name: "learningMachine",
    component: resolve => require(["@/views/learningMachine/learningMachine"], resolve),
    meta: {
      title: "笔果AI学习机",
    },
  },
  {
    path: "/allComment",
    name: "allComment",
    component: resolve => require(["@/views/learningMachine/allComment"], resolve),
    meta: {
      title: "全部评论",
    },
  },
  {
    path: "/learningMachineOrder",
    name: "learningMachineOrder",
    component: resolve => require(["@/views/learningMachine/learningMachineOrder"], resolve),
    meta: {
      title: "我的订单",
    },
  },
  {
    path: "/learningMachineAddress",
    name: "learningMachineAddress",
    component: resolve => require(["@/views/learningMachine/address"], resolve),
    meta: {
      title: "收货地址",
    },
  },
  {
    path: "/afterSales",
    name: "afterSales",
    component: resolve => require(["@/views/learningMachine/afterSales"], resolve),
    meta: {
      title: "售后服务",
    },
  },
  {
    path: "/afterSalesProgress",
    name: "afterSalesProgress",
    component: resolve => require(["@/views/learningMachine/afterSalesProgress"], resolve),
    meta: {
      title: "售后服务",
    },
  },
  {
    path: "/learningMachineWx",
    name: "learningMachineWx",
    component: resolve => require(["@/views/learningMachineWx/learningMachine"], resolve),
    meta: {
      title: "笔果AI学习机",//(微信)
    },
  },
  {
    path: "/learningMachineOrderWx",
    name: "learningMachineOrderWx",
    component: resolve => require(["@/views/learningMachineWx/learningMachineOrder"], resolve),
    meta: {
      title: "我的订单",//(微信)
    },
  },
  {
    path: "/learningMachineAddressWx",
    name: "learningMachineAddressWx",
    component: resolve => require(["@/views/learningMachineWx/address"], resolve),
    meta: {
      title: "收货地址",//(微信)
    },
  },
  {
    path: "/learningMachineStudy",
    name: "learningMachineStudy",
    component: resolve => require(["@/views/learningMachineStudy"], resolve),
    meta: {
      title: "学习机",
    },
  },
     {
    path: "/educationalAdvancement",
    name: "educationalAdvancement",
    component: resolve => require(["@/views/educationalAdvancement"], resolve),
    meta: {
      title: "1对1置顶学历提升方案",
    },
  },
  {
    path: "/julyActivity",
    name: "julyActivity",
    component: resolve => require(["@/views/julyActivity"], resolve),
    meta: {
      title: "笔果冲刺营",
    },
  },
  {
    path: "/gridLotteryDraw",
    name: "gridLotteryDraw",
    component: resolve => require(["@/views/gridLotteryDraw"], resolve),
    meta: {
      title: "App上线8周年",
    },
  },
  {
    path: "/activityInfo",
    name: "activityInfo",
    component: resolve => require(["@/views/activityInfo"], resolve),
    meta: {
      title: "活动详情",
    },
  },
  {
    path: "/marketingPrizeWheel",
    name: "prizeWheel",
    component: resolve => require(["@/views/marketingCampaign/prizeWheel"], resolve),
    meta: {
      title: "抽奖活动-转盘",
    },
  },
  {
    path: "/marketingReceiveAward",
    name: "receiveAward",
    component: resolve => require(["@/views/marketingCampaign/receiveAward"], resolve),
    meta: {
      title: "抽奖活动-直接领取",
    },
  },
  {
    path: "/marketingEggFrenzy",
    name: "eggFrenzy",
    component: resolve => require(["@/views/marketingCampaign/eggFrenzy"], resolve),
    meta: {
      title: "抽奖活动-砸金蛋",
    },
  },
    {
      path: "/marketingDirectLottery",
      name: "directLottery",
      component: resolve => require(["@/views/marketingCampaign/directLottery"], resolve),
      meta: {
        title: "抽奖活动-直接开奖",
      },
    },
    {
      path: "/marketingRedPacketLottery",
      name: "redPacketLottery",
      component: resolve => require(["@/views/marketingCampaign/redPacketLottery"], resolve),
      meta: {
        title: "抽奖活动-翻红包",
      },
    },
    {
      path: "/receiveGroupCard",
      name: "receiveGroupCard",
      component: resolve => require(["@/views/receiveGroupCard"], resolve),
      meta: {
        title: "领取成团卡",
      },
    },
    {
      path: "/groupCard",
      name: "groupCard",
      component: resolve => require(["@/views/groupCard"], resolve),
      meta: {
        title: "成团卡",
      },
    },
    {
      path: "/examBenefits",
      name: "examBenefits",
      component: resolve => require(["@/views/examBenefits"], resolve),
      meta: {
        title: "自考福利",
      },
    },
    {
      path: "/newUserBenefits",
      name: "newUserBenefits",
      component: resolve => require(["@/views/newUserBenefits"], resolve),
      meta: {
        title: "新用户专属福利",
      },
    },
    {
      path: "/forwardMomentsQuestionBank",
      name: "forwardMomentsQuestionBank",
      component: resolve => require(["@/views/forwardMomentsQuestionBank"], resolve),
      meta: {
        title: "转发朋友圈开通题库",
      },
    },
    {
      path: "/afterSalesOpenApp",
      name: "afterSalesOpenApp",
      component: resolve => require(["@/views/afterSalesOpenApp"], resolve),
      meta: {
        title: "异常售后工单中心",
      },
    },
    {
      path: "/assistWithApplication",
      name: "assistWithApplication",
      component: resolve => require(["@/views/assistWithApplication"], resolve),
      meta: {
        title: "课时协助服务",
      },
    },
    {
      path: "/studyGroup",
      name: "studyGroup",
      component: resolve => require(["@/views/studyGroup"], resolve),
      meta: {
        title: "学习小组",
      },
    },
    {
      path: "/examDetail",
      name: "examDetail",
      component: resolve => require(["@/views/examDetail"], resolve),
      meta: {
        title: "考试详情",
      },
    },
    {
      path: "/aiRecitation",
      name: "aiRecitation",
      component: resolve => require(["@/views/aiRecitation"], resolve),
      meta: {
        title: "AI背书",
        requiresPublicLogin: true,
      },
    },
    {
      path: "/aiFlashcard",
      name: "aiFlashcard",
      component: resolve => require(["@/views/aiFlashcard"], resolve),
      meta: {
        title: "AI闪记卡",
        requiresPublicLogin: true,
      },
    },
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js